export default __webpack_public_path__ + "static/media/eccenaviga6.8f81b310.jpg";